// 分类/全部，搜索页另外建
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { InfiniteScroll } from 'antd-mobile'
import { ProductSearchBar } from '../../../components_renew/Mall/ProductSearchBar'
import { DotLoadingInBlock } from '../../../components_renew/common/DotLoadingInBlock'
import { Container, Header, Wrapper } from '../../../components_renew/Layout'
import { TabBar } from '../../../components_renew/Mall/TabBar'
import { ProductListItem } from '../../../components_renew/Mall/ProductListItem'
import {
  clearProductListSearch,
  requestCartData,
  requestProductListData,
  setProductDetailsData
} from '../../../actions/mallAction'
import { defaultData } from '../../../reducers/mallProductListReducer'
import { handleCatch, postMessage } from '../../../utils'

@withRouter
@connect((state) => {
  let { loading, data, index } = state.mallProductList
  let listData = data[index] ? data[index] : defaultData
  return {
    loading,
    index,
    ...listData
  }
})
class ProductList extends React.PureComponent {
  componentDidMount () {
    let { list, index } = this.props
    if (!(list.length > 0)) {
      this.props.dispatch(requestProductListData({ index }))
    }
  }

  render () {
    let { list, loading, keyword, isLastPage } = this.props
    return <Container>
      {/*todo SearchBar与Header镶嵌*/}
      {/*{todo search完后index变成了search，后退回来后列表依然是search...}*/}
      <Header>商品列表</Header>
      <ProductSearchBar defaultValue={keyword} onSearch={this.onSearchSubmit}/>
      <Wrapper flex>
        <div>
          {list.map((item, index) => {
            return <ProductListItem key={index}
                                    {...item}
                                    onClick={this.toProductDetails.bind(this, item)}
                                    onIconClick={this.addCart}
            />
          })}
        </div>
        {
          list.length > 0 ?
            <div>
              <InfiniteScroll hasMore={!isLastPage} loadMore={this.onEndReached}/>
            </div>
            : loading && <DotLoadingInBlock/>
        }
      </Wrapper>
      <TabBar/>
    </Container>
  }

  onSearchSubmit = keyword => {
    this.props.dispatch(clearProductListSearch())
    this.props.dispatch(requestProductListData({ index: 'search', pageIndex: 1, keyword }))
    this.props.history.push(window.PATH.MALL_PRODUCT_SEARCH)
  }

  onEndReached = () => {
    let { loading, isLastPage, pageIndex, index } = this.props
    if (loading || isLastPage) return
    this.props.dispatch(requestProductListData({ pageIndex: pageIndex + 1, index }))
  }

  toProductDetails = (data) => {
    this.props.dispatch(setProductDetailsData(data))
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${data['id']}`)
  }

  addCart = ({ id }) => {
    // 库存不足应该将有服务器判断，而且应在下单时判断
    // if (!(stock > 0)) {
    //   window.toast.fail('库存不足', 1)
    //   return
    // }
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        postMessage({ type: 'loginRequest' })
      })
    } else {
      let config = {
        method: 'post', url: window.API.Mall.postCartItem,
        data: { productId: id, productCount: 1 }
      }
      window.toast.show('')
      window.axios.request(config)
        .then(() => {
          this.props.dispatch(requestCartData())
          window.toast.info('已添加至购物车')
        })
        .catch(handleCatch)
    }
  }

}

export { ProductList }
